import { Grid, Theme, useMediaQuery } from "@mui/material"
import { useHistory } from "react-router-dom"
import OperationButtonContained from "../../../components/Operations/styled/OperationButtonContained"
import OperationButtonOutlined from "../../../components/Operations/styled/OperationButtonOutlined"
import OperationTextGrid from "../../../components/Operations/styled/OperationTextGrid"
import OperationTypographyInstruction from "../../../components/Operations/styled/OperationTypographyInstruction"
import { IOperationsStatus, ModalityType } from "../../../types/FaceVerification"
import OperationTypographyLabelText from "../../../components/Operations/styled/OperationTypographyLabelText"

interface ICheckSideBar {
    checkState: IOperationsStatus
    activeModality: ModalityType | null
    start: () => void
    cancel?: () => void
    restart: () => void
}

const CheckSideBar: React.FC<ICheckSideBar> = (props) => {

    const history = useHistory()
    const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));

    const getButtons = () => {
        if (props.activeModality === ModalityType.OVERVIEW) {
            return (
                <OperationButtonContained onClick={() => history.push("/")} color="primary" variant="contained">
                    Finish
                </OperationButtonContained>
            )
        }
        switch(props.checkState) {
            case IOperationsStatus.IDLE:
                return (
                    <OperationButtonContained onClick={props.start} color="primary" variant="contained">
                        Start capture
                    </OperationButtonContained>
                ) 
            case IOperationsStatus.ACTIVE:
                return (
                    <OperationButtonContained onClick={props.cancel} color="primary" variant="contained">
                        Cancel
                    </OperationButtonContained>
                ) 
            case IOperationsStatus.DONE:
                return (
                    <>
                        <OperationButtonContained onClick={props.restart} color="primary" variant="contained">
                            Recapture
                        </OperationButtonContained>
                        <OperationButtonOutlined color="primary" variant="outlined" onClick={() => {history.push("/")}}>
                            Home
                        </OperationButtonOutlined>
                    </>
                )
            case IOperationsStatus.SUCCESS:
                return (
                    <>
                        <OperationButtonContained onClick={props.restart} color="primary" variant="contained">
                            Recapture
                        </OperationButtonContained>
                        <OperationButtonOutlined color="primary" variant="outlined" onClick={() => {history.push("/")}}>
                            Home
                        </OperationButtonOutlined>
                    </>
                ) 
        }
    }

    const getModalityText = () => {
        switch(props.activeModality) {
            case ModalityType.FACE_MODALITY:
                return (
                    <Grid item xs={12}>
                        {!isMobile || (props.checkState !== IOperationsStatus.ACTIVE && props.checkState !== IOperationsStatus.SUCCESS)? 
                            <>
                                <OperationTypographyInstruction>
                                    Take a selfie
                                </OperationTypographyInstruction>
                                <OperationTypographyLabelText>
                                    Adjust your position to place your face into oval frame and press <b>Start capture</b>.
                                </OperationTypographyLabelText>
                            </>
                            : null
                        }
                        {getButtons()}
                    </Grid>
                )
            case ModalityType.OVERVIEW:
                return (
                    <Grid item xs={12}>
                        {!isMobile || (props.checkState !== IOperationsStatus.ACTIVE && props.checkState !== IOperationsStatus.SUCCESS)? 
                            <>
                                <OperationTypographyInstruction>
                                    Preview captured data
                                </OperationTypographyInstruction>
                            </>
                            : null
                        }
                        {getButtons()}
                    </Grid>
                )
        }
    }

    return (
        <OperationTextGrid item md={2} xs={12} glow={(props.checkState !== IOperationsStatus.ACTIVE)}>
            {getModalityText()}
        </OperationTextGrid>
    )
}

export default CheckSideBar